import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import html2canvas from "html2canvas";
import * as htmlToImage from "html-to-image";
// 👉 Internal API call (used once inside component)
const sendFeedbackApi = async (payload) => {
  const response = await fetch("/api/admin/feedback", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to send feedback");
  }

  return response.json();
};

const ScreenFeedback = ({
  targetRef,
  buttonLabel = "Report Issue",
  buttonVariant = "danger",
}) => {
  const [show, setShow] = useState(false);
  const [screenshot, setScreenshot] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const screenName = window.location.pathname;

  const handleCapture = async () => {
    try {
      const element = document.querySelector("#root") || document.body;

      if (!element) {
        console.error("No element found for screenshot");
        return;
      }

      const dataUrl = await htmlToImage.toJpeg(element, {
        quality: 0.6,
        pixelRatio: 1,
        backgroundColor: "#fff",
        cacheBust: true,
        skipFonts: true, // 👈 ADD THIS
      });

      setScreenshot(dataUrl);
      setShow(true);
    } catch (error) {
      console.error("Screenshot failed:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        screenName,
        comment,
        screenshot,
        url: window.location.href,
        // browser: navigator.userAgent,
        // createdAt: new Date(),
      };

      console.log(payload);

      //   await sendFeedbackApi(payload);

      // reset
      setComment("");
      setScreenshot(null);
      setShow(false);
    } catch (err) {
      console.error("Submit failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant={buttonVariant} onClick={handleCapture}>
        {buttonLabel}
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Report Issue</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {screenshot && (
            <div className="mb-3 text-center">
              <img
                src={screenshot}
                alt="Screenshot"
                style={{ width: "100%", borderRadius: 8 }}
              />
            </div>
          )}

          <Form.Group>
            <Form.Label>Describe the issue</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter details..."
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading || !comment}
          >
            {loading ? <Spinner size="sm" /> : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ScreenFeedback;
